import React from 'react';
import { GlobalFilterHandle } from '../../../context/types';
import { filterColors, teal2 } from '../../theme';
import { useDashboardPageOptionsContext } from '../dashboards/contexts';
import { FilterSection } from '../filter/types';
import { FilterDrawer } from './FilterDrawer';
import { FilterState } from './types';

interface FilterDrawerProps {
  drawerState: FilterState;
  setDrawerState: (value: FilterState) => void;
  isFullScreen: boolean;
  filterSections: FilterSection[];
  filterHandle: GlobalFilterHandle;
}

export const FilterFilterDrawer = (props: FilterDrawerProps) => {
  const {
    isFullScreen,
    drawerState,
    setDrawerState,
    filterSections,
    filterHandle,
  } = props;
  const dashboardPageOptions = useDashboardPageOptionsContext();
  const myFiltersOptions = dashboardPageOptions.filterTray?.myFilters;
  return (
    <FilterDrawer
      isFullScreen={isFullScreen}
      opened={drawerState}
      setClosed={() => setDrawerState('closed')}
      filterSections={filterSections}
      filterHandle={filterHandle}
      keyPrefix={'filter'}
      options={{
        mainBackgroundColor: teal2,
        backgroundColors: filterColors,
        titleKey: 'common:filterTray.filterTray',
        myFilters: myFiltersOptions,
      }}
    />
  );
};
